import * as React from "react";
import { Link, Typography, useTheme } from "@mui/material";

export function Title5({ title, sx }) {
  const theme = useTheme();
  return <h5 style={{ ...theme.Title5, ...sx }}>{title}</h5>;
}

export function Title4({ title, sx }) {
  const theme = useTheme();
  return <h5 style={{ ...theme.Title4, ...sx }}>{title}</h5>;
}

export function PlainText(props) {
  const theme = useTheme();
  return (
    <Typography variant="caption" sx={{ ...theme.PlainText, ...props.sx }}>
      {props.children}
    </Typography>
  );
}

export function PlainTextSmall(props) {
  const theme = useTheme();
  return <p style={theme.PlainTextSmall}>{props.children}</p>;
}

export function SecondaryTextSmall(props) {
  const theme = useTheme();
  return (
    <Typography
      variant="caption"
      sx={{ ...theme.SecondaryTextSmall, ...props?.sx }}
    >
      {props.children}
    </Typography>
  );
}

export function Link1(props) {
  const theme = useTheme();
  return (
    <Link
      href={props?.href}
      sx={{ ...theme.Link1, ...props.sx }}
      color={props?.color || "text.link"}
      target={props?.target || ""}
      onClick={props.onClick}
    >
      {props.children}
    </Link>
  );
}

export function Link2(props) {
  const theme = useTheme();
  return (
    <Link
      href={props?.href}
      style={theme.Link2}
      color={props?.color || "primary"}
      target={props?.target || ""}
    >
      {props.children}
    </Link>
  );
}

export function IndentSpace({ size }) {
  return <span style={{ display: "inline-flex", width: size }}></span>;
}
